/**
 * Base classes for the component.
 * @type {String}
 */
export const BASE_CLASSES = 'fit-collapsible';

/**
 * The expand/minimize animation's steps amount.
 * @type {Number}
 */
export const ANIMATION_STEP_AMOUNT = 12;
